<script setup>
import Select2 from '@/components/inputs/Select2.vue';
import ge from '@/api/ge';
import { computed, nextTick, onMounted, ref, useTemplateRef } from 'vue';

const props = defineProps({
  modelValue: { type: [Number, String, Array], default: undefined },
  queryParams: { type: Object, default: () => ({ visible: true }) },
  name: { type: String, default: null },
  multiple: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'modalidades-cargadas']);

const select2Input = useTemplateRef('select2');

const modalidades = ref([]);
const settings = computed(() => ({
  multiple: props.multiple,
  selectGroups: true,
}));

onMounted(() => {
  ge.modalidades.getAgrupadasSelect2({ params: props.queryParams })
    .then((data) => {
      modalidades.value = data;
      // Lo lanzamos al siguiente tick para que select ya haya cargado las modalidades
      // y asignado la seleccionada
      nextTick(() => {
        emit('modalidades-cargadas', modalidades.value);
      });
    });
});

function selectedData() {
  return select2Input.value.selectedData();
}

defineExpose({ selectedData });
</script>
<template>
  <Select2
    ref="select2"
    style="width:100%"
    :name="name"
    :model-value="modelValue"
    :settings="settings"
    :options="modalidades"
    v-bind="$attrs"
    @update:model-value="$emit('update:modelValue', $event)"
  ></Select2>
</template>
